
import React from "react";

export const CocCollectionDetailContext = React.createContext(null);

export const useCocCollectionDetailContext = () => {
  const context = React.useContext(CocCollectionDetailContext);

  if (!context) throw new Error("COC collection Detail Context not provided!");

  return context;
};
